import React from "react";
import Container from "@mui/material/Container";
import { ThemeProvider, createTheme } from "@mui/material/styles";

const MainLayout = ({ children }) => {
  return (
  <Container
  maxWidth={false}      // ← disables the fixed max‑width
  disableGutters        // ← remove default left/right padding (optional)
  sx={{
    paddingTop: 0,
    marginTop: "-20px",
    // ml: "-20px",      // avoid negative margin if possible
    width: "100%",       // ensure it uses full width
  }}
>
  {children}
</Container>

  );

  
};

export default MainLayout;
